import { DUR } from '@/animations/vars'
import TransitionIn from './TransitionIn'
import TransitionOut from './TransitionOut'
import { TransitionTypes } from './types'

const transitionDurations: Record<TransitionTypes | string, number> = {
  slide: DUR.default,
  fade: DUR.default * (1 / 4)
}

export { transitionDurations, TransitionIn, TransitionOut }
